module.exports = __webpack_public_path__ + "static/media/account.dd0df253.svg";